import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// components
import CommonModal from "../../../components/modal/CommonModal";

// api
import { deleteSignupDpdtx006AdminFromMomthera } from "../../../services/apis/momthera/user";


function MomtheraMyPageWithdrawalIdentification() {
    const navigate = useNavigate();
    
    const [password, setPassword] = useState("");

    const [isNonValidPW, setIsNonValidPW] = useState(false);

    const [showWithdrawalModal, setShowWithdrawalModal] = useState(false);

    function goToMyPageMain() {
        navigate("/dtx006/mypage");
    }

    // withdrawal modal
    const closeWithdrawalModal = () => {
        setShowWithdrawalModal(false);
        localStorage.removeItem('dtx006token');
        navigate('/sign-in/dtx006');
    }

    const WithdrawalModalBody = (
        <div className="mypage_modal_body">정상적으로 탈퇴되었습니다.</div>
    )

    const WithdrawalModalFooter = (
        <div className="mypage_modal_footer">
            <button className="submit complete" type="button" onClick={closeWithdrawalModal} style={{ width: '100%' }}>확인</button>
        </div>
    )

    const handleWithdrawal = async () => {
        try {
            const res = await deleteSignupDpdtx006AdminFromMomthera(password);
            if(Math.floor(res.status/100)===2){
                setShowWithdrawalModal(true);
            }else{
                throw new Error();
            }
        }catch{
            setIsNonValidPW(true);
        }
    }

    return (
        <div className="dashboardContent dtx006">
			<div className="dashboardContent__title">
				<span className="dashboardContent__title__content">마이페이지</span>
			</div>
            <div className="mypage_center_box_wrapper mypage_withdrawal_wrapper">
                <div className="title_wrapper" style={{left: 0}}>
                    <div className="title">회원탈퇴</div>
                    <div className="description">
                        회원 탈퇴 마지막 단계입니다.<br/>
                        본인 확인을 위한 비밀번호를 입력해주세요.
                    </div>
                </div>
                <div className="center_box" style={{marginBottom: '4.375rem'}}>
                    <div className="input_wrapper modify_pw_input_wrapper">
                        <div className="input_label">비밀번호</div>
                        <input
                            type="password"
                            value={password.prev}
                            onChange={(e)=>{
                                setIsNonValidPW(false);
                                setPassword(e.target.value)
                            }}
                            style={{ borderColor: "#707070" }}
                            placeholder="사용중인 비밀번호를 입력 해주세요."
                        />
                        {isNonValidPW && <div className="validation" style={{bottom: '-0.125rem'}}>비밀번호가 일치하지 않습니다.</div>}
                    </div>
                </div>
                <div>
                    <div className="withdrawal_button_wrapper">
                        <button className="withdrawal_btn" onClick={handleWithdrawal} disabled={!password}>탈퇴</button>
                        <button className="cancel_btn" onClick={goToMyPageMain}>취소</button>
                    </div>
                </div>
                <CommonModal
                    header="회원 탈퇴"
                    body={WithdrawalModalBody}
                    footer={WithdrawalModalFooter}
                    show={showWithdrawalModal}
                    setClose={closeWithdrawalModal}
                    size="sm"
                />
            </div>
        </div>
    );
}

export default MomtheraMyPageWithdrawalIdentification;